export default __webpack_public_path__ + "static/epp-logo-8072b88e3f5b509bc86ce59519337498.svg";